import { ChatModel } from './chat.model';
import { UserModel, ImageModel } from './user.model';
export interface ProductModel {
    id: number;
    favorited?: boolean;
    title: string;
    description: string;
    user: UserModel;
    price: number;
    brand: ProductBrandModel;
    condition: ProductConditionModel;
    category: ProductCategoryModel;
    type: ProductTypeModel;
    color: ProductColorModel;
    is_active: string;
    size: ProductSizeModel;
    shoe: string;
    images: Array<ImageModel>;
    location: string;
    latitude: number;
    longitude: number;
    offers_count: number;
    swap_request_offer?: OfferDetailModel;
    incoming_swap_request?: OfferDetailModel;
    swap_request_allowed: boolean;
    created_at: string;
    chat_id: string;
}

export interface ProductCategoryModel {
    id: number;
    title: string;
    parent_id: number;
    images: Array<ImageModel>;
    icon?: string | null;
}

export interface ProductBrandModel {
    id: number;
    name: string;
}

export interface ProductTypeModel {
    id: number;
    title: string;
}

export interface ProductConditionModel {
    id: number;
    title: string;
    rating: number;
}

export interface ProductTypeModel {
    id: number;
    title: string;
}

export interface ProductColorModel {
    id: number;
    title: string;
    code: string;
}

export interface ProductSizeModel {
    id: number;
    code: string;
    type_id: number;
    category_id: number;
    title: string;
}

export interface OfferModel {
    type: string;
    offer: OfferDetailModel;
}

export interface OfferDetailModel {
    id: number;
    product: ProductModel;
    sent_by: UserModel;
    sent_to: UserModel;
    status: string;
    original_price: number;
    offered_price: number;
    offer_type: string;
    offered_product: ProductModel;
    offer_description: string;
    counter_count: number;
    chat?: ChatModel
}

export class ProductListingParamsModel {
    category_id?: number;
    condition_id?: number;
    search?: string;
    brand_id?: number;
    type_id?: number;
    color_id?: number;
    price_from?: number;
    price_to?: number;
    size_id?: number;
    location?: number;
    latitude?: number;
    longitude?: number;
    page?: number;
    other?: string;
    sort?: string;
    direction?: string;
    user_id?: number;
}

export interface SizeSelectModel {
    key: number;
    value: string;
}
